import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormItemBaseComponent} from "../../bases/form-item-base-component";
import {MatInput} from "@angular/material/input";
import {FolderSelectorStore} from "./folder-selector.store";
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-folder-selector',
  templateUrl: './folder-selector.component.html',
  styleUrls: ['./folder-selector.component.scss'],
  providers: [FolderSelectorStore]
})
export class FolderSelectorComponent extends FormItemBaseComponent implements OnInit, AfterViewInit {
  @ViewChild(MatInput) public input: MatInput;

  @Input('folderIdToMove') set _folder(id: number) {
    this._folderSelectorStore.initFolderId(id);
  }

  public readonly selected$ = this._folderSelectorStore.selected$;
  public readonly path$ = this._folderSelectorStore.path$;

  constructor(
    private readonly _folderSelectorStore: FolderSelectorStore,
    private readonly _route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    if ('folder' in this._route.snapshot.queryParams) {
      this.control.setValue(parseInt(this._route.snapshot.queryParams.folder));
    }
  }

  ngAfterViewInit(): void {
    this._folderSelectorStore.initControl(this.control);
  }

  public inputOnFocus(): void {
    this._folderSelectorStore.openFolderSelectorDialog();
  }

}
